import {
    Box,
    Button,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import { CloseIcon } from "src/icons/CloseIcon";
import { theme } from "src/theme/mui-theme";
import { ts } from "src/utils/translate";
import { countries } from "src/utils/countries";
import { ProjectWizardLabels } from "src/pages/ProjectDetailsWizard/ProjectWizardLabels";

interface ProjectDetailsStepProps {
    onNext: () => void;
    onClose: () => void;
    formData: any;
    setFormData: (data: any) => void;
}

export const ProjectWizardDetailsStep = ({ onNext, onClose, formData, setFormData }: ProjectDetailsStepProps) => {

    const handleChange = (field: string) => (e: any) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const handleSelectChange = (field: string) => (e: any) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    return (
        <Box padding={5} paddingTop={3} minWidth={500}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" >
                <Box>
                    <Typography variant="h6" color={theme.palette.text.primary}>
                        {ts('enter_your_project_details', 'Enter Your Project Details')}
                    </Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary} sx={{ marginTop: 1 }}>
                        {ts('fill_necessary_information_to_start', 'Fill in the necessary information to get started and create your project.')}
                    </Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ marginTop: -2, marginRight: -4 }}>
                    <CloseIcon sx={{ fontSize: 20, color: theme.palette.text.primary }} />
                </IconButton>
            </Box>

            <Divider sx={{ marginTop: 2 }} />

            <Box display="flex" flexDirection="column" gap={4} marginTop={4} sx={{ position: 'relative' }}>
                <TextField
                    label={ts('project_name_label', 'Project name')}
                    variant="outlined"
                    value={formData.name || ""}
                    onChange={handleChange("name")}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                />
                <FormControl fullWidth size="small" variant="outlined">
                    <InputLabel id="country-label">{ts("country", "Country")}</InputLabel>
                    <Select
                        labelId="country-label"
                        id="country-select"
                        value={formData.country || ""}
                        onChange={handleSelectChange("country")}
                        label={ts("country", "Country")}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
                    >
                        {countries.map((country) => (
                            <MenuItem key={country} value={country}>
                                {country}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label={ts('city', 'City')}
                    variant="outlined"
                    value={formData.city || ""}
                    onChange={handleChange("city")}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label={ts('project_address_label', 'Address')}
                    variant="outlined"
                    value={formData.address || ""}
                    onChange={handleChange("address")}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label={ts('zip_code', 'Zip code')}
                    variant="outlined"
                    value={formData.zip || ""}
                    onChange={handleChange("zip")}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                />
                <ProjectWizardLabels formData={formData} setFormData={setFormData} />
            </Box>

            <Box display="flex" justifyContent="flex-end" marginTop={8}>
                <Button variant="contained" onClick={onNext} sx={{ width: 120 }}>
                    { formData.id ? (
                        ts('save_word', 'Save')
                    ) : (
                        ts('next_button_label', 'Next')
                    )}
                </Button>
            </Box>
        </Box>
    );
};
